var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logon_wrap"},[_c('TopNav'),_c('div',{staticClass:"c_outer"},[_c(_vm.curComponent,{tag:"component",staticClass:"c_inner",on:{"next-step":_vm.nextStep}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }